import { FSK_REGIONS } from '../../constants/fsk';

export function isFskRegions(regions: number[] | null, parentRegionId: number | null) {
  const candidates = new Set<number>(regions ?? []);

  if (parentRegionId != null) {
    candidates.add(parentRegionId);
  }

  if (candidates.size === 0) {
    return false;
  }

  return FSK_REGIONS.some(id => candidates.has(id));
}
